import { theme as defaultTheme } from '../../../theme';

export const getTheme = (props) => (props.theme && props.theme.typography ? props.theme : defaultTheme);

export const getColorValue = (themeColors, colorKey) => {
  if (!colorKey) return undefined;
  if (colorKey === 'danger') {
    return themeColors && themeColors.feedback && themeColors.feedback.error
      ? themeColors.feedback.error
      : undefined;
  }
  const brand = themeColors && themeColors.brand ? themeColors.brand[colorKey] : undefined;
  if (brand) return brand;
  const text = themeColors && themeColors.text ? themeColors.text[colorKey] : undefined;
  if (text) return text;
  const feedback = themeColors && themeColors.feedback ? themeColors.feedback[colorKey] : undefined;
  if (feedback) return feedback;
  return colorKey;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Typography/utils/typographyHelpers.js